// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"b0f9e46007fa6d34","777":"f5e97ee08ff4011e"}[chunkId] + ".js";
};